let ENV;

const hostname = window && window.location && window.location.hostname;

if(hostname === 'cams.frankwatching.com' || hostname === 'cams-prd.firebaseapp.com' ) {
	ENV = 'PRODUCTION';
} else if(hostname === 'acc.cams.frankwatching.com' || hostname === 'cams-acc.firebaseapp.com' ) {
	ENV = 'ACCEPTANCE';
} else {
	ENV = 'DEVELOPMENT';
}

export const ENVIRONMENT = ENV;


// WEBPACK FOOTER //
// ./src/config/environment.js